import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { ledgerApi } from "@/api/mist";

// Founder-only persistent low-balance heading. Silently renders nothing for
// non-founders (the endpoint 403s) or when there are no alerts.
export function LedgerAlertHeading({ onManage }) {
  const [heading, setHeading] = useState(null);
  const [count, setCount] = useState(0);

  useEffect(() => {
    let alive = true;
    const load = () => ledgerApi.alerts()
      .then((d) => { if (alive) { setHeading(d.heading || null); setCount(d.alert_count || 0); } })
      .catch(() => { if (alive) { setHeading(null); setCount(0); } });
    load();
    const t = setInterval(load, 60000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!heading) return null;
  return (
    <div data-testid="ledger-alert-heading"
      className="sticky top-0 z-10 flex items-center gap-2 border-2 border-black bg-[#ff5a3c] text-black px-3 py-2 rounded-lg shadow-[3px_3px_0px_#000]">
      <AlertTriangle size={16} strokeWidth={2.6} className="shrink-0" />
      <span className="flex-1 font-mono text-[10px] font-black uppercase tracking-wide leading-snug">{heading}</span>
      {onManage && (
        <button onClick={onManage} data-testid="ledger-alert-manage"
          className="shrink-0 border-2 border-black bg-black text-[#ffcf3f] font-mono text-[9px] font-black uppercase tracking-widest px-2 py-1 rounded active:translate-y-[1px]">
          Top up{count > 1 ? ` (${count})` : ""}
        </button>
      )}
    </div>
  );
}
